<mat-horizontal-stepper #stepper [linear]="isLinear">

    <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
            <ng-template matStepLabel>
                <div>
                    <span active>Paste Cascade</span>
                </div>
            </ng-template>

            <div   class="mt-3 flex-gap-15px flex-row">
                <div class="flex-50" >
                    <mat-card appearance="outlined" style="height: 450px; overflow: scroll;">
                        <mat-card-header>
                            <mat-card-title>Cascade Path</mat-card-title>
                            <mat-card-subtitle>
                                Select menu path below to apply item updates
                                <mat-icon id="icon-help"
                                          fontIcon="help_outline"
                                          matTooltip="Find selected parent from anywhere on selected submenus">
                                </mat-icon>
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content class="ml-3">
                            <div>
                                <div class="filter-grp-wrapper">
                                    <form [formGroup]="searchForm">
                                        <mat-form-field [style.width]="'430px'" [style.margin-top]="'5px'" [style.margin-bottom]="'0'">
                                            <input
                                                matInput
                                                [attr.data-testid]="'submenu_checkbox_search_bar'"
                                                placeholder="Search"
                                                formControlName="searchTerm"
                                                (input)="onCascadeFilter($event)">
                                            <div class="filter-size" [matBadge]="filterSize" matBadgePosition="after" matBadgeColor="warn"></div>
                                            <button matSuffix
                                                    mat-icon-button aria-label="Clear" (click)="resetFilter()"
                                                    [attr.data-testid]="'clear_search_term_button'">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </form>
                                </div>
                                <mat-list style="height:158px; padding-top:0; overflow: scroll;">
                                    <mat-list-item  *ngFor="let submenu of (cascadeSubmenus$ | async)" style="height: 40px;" class="flex-column">
                                        <mat-checkbox
                                            [checked]="currentSubmenu === submenu.id || submenu.checked"
                                            [disabled]="currentSubmenu === submenu.id"
                                            (change)="updateAllSelected($event.checked, submenu.id)">
                                            {{submenu.name}}&nbsp;-&nbsp;{{submenu.id}}
                                        </mat-checkbox>
                                    </mat-list-item>
                                </mat-list>
                            </div>
                            <div class="mt-4">
                                <h6>Select parent ancestors to apply</h6>
                                <mat-chip-listbox aria-label="Parents Path" class="mat-mdc-chip-set-stacked">
                                    <div *ngFor="let chip of bottomChips" class="flex-row" >
                                        <mat-icon class="mt-1">expand_more</mat-icon>
                                        <mat-chip-option
                                            [matTooltip]="chip.tag"
                                            matTooltipPosition="right"
                                            [ngClass]="chip.selected ? 'selected': 'deselected'"
                                            (click)="toggleSelectBottomChip(chip)"
                                        >{{ chip.name }}</mat-chip-option>
                                    </div>
                                </mat-chip-listbox>
                            </div>
                            <br><!-- todo: is this <br> necessary? -->
                            <div class="status">
                                <mat-progress-spinner
                                    *ngIf="spinner"
                                    [color]="color"
                                    [diameter]="diameter"
                                    [mode]="mode"
                                >
                                </mat-progress-spinner>
                                <div *ngIf="!spinner" class="flex-row" >
                                    <div><strong>Found {{ matchCount }} matches for path</strong></div>
                                    <div><button mat-icon-button class="info" (click)="togglePath()">
                                        <mat-icon class="icon">info</mat-icon></button></div>
                                </div>
                            </div>
                            <div *ngIf="showPath"><code>{{ path }}</code></div>
                            <div>
                                Paste to Top or Bottom?
                                <mat-radio-button
                                    [disabled]="bottomSelected | async"
                                    (click)="setTopSelected()"
                                >Top</mat-radio-button>
                                <mat-radio-button
                                    [disabled]="topSelected | async"
                                    (click)="setBottomSelected()"
                                >Bottom</mat-radio-button>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="flex-50" >
                    <mat-card appearance="outlined" style="height: 450px; overflow: scroll;">
                        <mat-card-header>
                            <mat-card-title>Item Updates</mat-card-title>
                            <mat-card-subtitle>
                                The following updates will be cascaded to item matches from selected path for this
                                menu.
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content class="ml-3">
                            <emm-dynamic-menu-form *ngIf="item" style="margin-top: 15px"
                                [attributes]="attributes$ | async"
                                [form]="form"
                                [isReadOnly]="true"
                                [isCascade]="true"
                            >
                            </emm-dynamic-menu-form>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

            <div  class="buttons flex-center-center">
                <button
                    [attr.data-testid]="'add_item_cancel_button'"
                    class="button-color"
                    mat-raised-button
                    matTooltip="Cancel"
                    (click)="onNoClick()"
                >Cancel</button>
                <button
                    [attr.data-testid]="'add_item_continue_button'"
                    class="button-color"
                    mat-raised-button
                    matStepperNext
                    matTooltip="Continue"
                    [disabled]="!((bottomSelected | async) || (topSelected | async))"
                >Continue</button>
            </div>
        </form>
    </mat-step>

    <mat-step>
        <div>
            <ng-template matStepLabel>Confirm Update</ng-template>
            <div>
                <div class="mb-2">
                    Are you sure you want to paste cascade to all <strong>{{ matchCount }}</strong>
                    matches of item path
                </div>
                <div *ngFor="let selectedParent of selectedBottomChips">
                    <div class="flex-row" >
                        <mat-icon class="icon">expand_more</mat-icon>
                        <h5 class="item-bold">{{ selectedParent.name }} ({{ selectedParent.tag }})</h5>
                    </div>
                </div>
                <ng-template #anywhere>
                    <div *ngIf="featureScope === 'Legacy'; else elseGlobal">across this entire menu?</div>
                    <ng-template #elseGlobal>
                        <div>across the selected submenus?</div>
                    </ng-template>
                    <br>
                </ng-template>
                <span class="descendantCount"><strong>Please note that this will create {{ descendantCount }} new nodes. Each node will have its own overrides.</strong></span>
            </div>
            <div class="buttons flex-center-center" >
                <button
                    [attr.data-testid]="'confirm_cancel_button'"
                    class="button-color"
                    mat-raised-button
                    matTooltip="Cancel"
                    (click)="onNoClick()"
                >Cancel</button>
                <button
                    [attr.data-testid]="'confirm_back_button'"
                    class="button-color"
                    mat-raised-button
                    matStepperPrevious
                    matTooltip="Back"
                >Back</button>
                <button
                    [attr.data-testid]="'confirm_yes_button'"
                    class="button-color"
                    mat-raised-button
                    matTooltip="Yes"
                    (click)="onSave()"
                >Yes</button>
            </div>
        </div>
    </mat-step>

</mat-horizontal-stepper>
